import { CartItem } from "@hatch-digital-nl/bravilor-storybook";
import { RefurbishedPendingOrderInterface } from "../../../common/interfaces/apiV2/refurbished/RefurbishedPendingOrderInterface";
import { mapOrderLineToCartItem } from "./mapOrderLineToCartItem";

export const getCartItemsFromPendingOrder = (
    pendingOrder: RefurbishedPendingOrderInterface | null,
): CartItem[] => {
    if (!pendingOrder?.order_lines.length) {
        return [];
    }

    return pendingOrder.order_lines.map(mapOrderLineToCartItem);
};
